module.exports = __webpack_public_path__ + "static/media/time_management.30fbb50d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/time_management.svg
// module id = 1083
// module chunks = 2